import * as z from 'zod'

import { SERVICE_OPTIONS } from '@/features/OurProducts/constants'
import { UTMDataSchema } from '@/lib/gtm/utmContext'

export const contactSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  surname: z.string().min(1, 'Surname is required'),
  email: z
    .string()
    .email({ message: 'Must be valid email' })
    .nonempty({ message: 'Email is required' }),
  tel: z.string().regex(/^\d{10}$/, 'Phone number must be 10 digits'),
  additionalDetail: z.string(),
  acceptedTerm: z.boolean(),
  agreedToMarketingConsent: z.boolean(),
  interestedProducts: z.enum(SERVICE_OPTIONS).array(),
  url: z.string(),
})

export const payloadSchema = contactSchema.extend({
  utm: UTMDataSchema,
})
